import classnames from 'classnames'
import React from 'react'
import {InitialsAvatar, type TestimonialInfo} from '../TestimonialCard'
import styles from './styles.module.css'
import Image from 'next/image'

const TestimonialTagColors = ['#D2D3F1', '#D7CBF7', '#C4D1E1', '#D9DDEF']

type TestimonialTag =
  | 'Corporation'
  | 'Nonprofit'
  | 'LLC'
  | 'Pre-seed'
  | 'Series A'
  | 'Post-IPO'
  | 'Tech'
  | 'Web 3'
  | 'Ecommerce'
  | 'Other'

type TestimonialType = 'Stages' | 'Business Types' | 'Industries'

type TestimonialTags = TestimonialTag[]

export type TestimonialCardWithTagsProps = TestimonialInfo & {
  tags: TestimonialTags
  testimonialType: TestimonialType
  testimonialCardClassName?: string
}

const Tags = ({tags}: {tags: TestimonialTags}) => (
  <div className={styles.testimonialTags}>
    {tags.map((tag, tagIndex) => (
      <div
        key={tag}
        className={styles.testimonialTag}
        style={{
          backgroundColor:
            TestimonialTagColors[tagIndex % TestimonialTagColors.length],
        }}
      >
        {tag}
      </div>
    ))}
  </div>
)

const TestimonialCardWithTags = ({
  testimonialType,
  tags,
  name,
  handle,
  src,
  testimonial,
  testimonialCardClassName,
  initialsAvatarBackgroundColor,
  initialsAvatarTextColor,
}: TestimonialCardWithTagsProps) => (
  <div
    className={classnames(styles.testimonialCardContainer, testimonialCardClassName)}
  >
    <div className={styles.testimonialTagsContainer}>
      <div className={styles.testimonialType}>{testimonialType}</div>
      <Tags tags={tags} />
    </div>
    <blockquote className={styles.testimonialCard}>
      <header className={styles.personInfoContainer}>
        <cite className={styles.personInfo}>
          {!src && (
            <InitialsAvatar
              name={name}
              backgroundColor={initialsAvatarBackgroundColor}
              textColor={initialsAvatarTextColor}
            />
          )}
          {src && <Image src={src} className={styles.personImage} alt="" />}
          <div>
            <p className={styles.personName}>{name}</p>
            <p className={styles.personTitle}>{handle}</p>
          </div>
        </cite>
      </header>
      <div className={styles.personTestimonial}>{testimonial}</div>
    </blockquote>
  </div>
)

export default TestimonialCardWithTags
